(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/sport-widget/assets/javascripts/sportradar-widget.js') >= 0) return;  svs.modules.push('/components/sport/sport-widget/assets/javascripts/sportradar-widget.js');
"use strict";

const _excluded = ["widgetType", "matchId", "theme", "widgetProps", "loading"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _svs$sport$sportradar = svs.sport.sportradar,
  createWidget = _svs$sport$sportradar.createWidget,
  SIRWidgetState = _svs$sport$sportradar.WidgetState;
const _svs$components$sport = svs.components.sportinfo.skeletonWrapper,
  SkeletonConfig = _svs$components$sport.SkeletonConfig,
  SkeletonWrapper = _svs$components$sport.SkeletonWrapper;
const SportradarWidgetState = {
  Loading: 1,
  Done: 2,
  Error: 3
};
const SportradarWidget = _ref => {
  let widgetType = _ref.widgetType,
    matchId = _ref.matchId,
    theme = _ref.theme,
    _ref$widgetProps = _ref.widgetProps,
    widgetProps = _ref$widgetProps === void 0 ? {} : _ref$widgetProps,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  const parentElement = useRef();
  const element = useRef();
  const _useState = useState(SportradarWidget.Loading),
    _useState2 = _slicedToArray(_useState, 2),
    widgetState = _useState2[0],
    setWidgetState = _useState2[1];
  const skeletonConfig = useMemo(() => {
    var _SkeletonConfig$widge;
    return (_SkeletonConfig$widge = SkeletonConfig[widgetType]) !== null && _SkeletonConfig$widge !== void 0 ? _SkeletonConfig$widge : SkeletonConfig.DEFAULT;
  }, [widgetType]);
  const showSkeleton = loading || widgetState !== SportradarWidgetState.Done && widgetState !== SportradarWidgetState.Error;
  const showError = !loading && widgetState === SportradarWidgetState.Error;
  useEffect(() => {
    let widget;
    if (!loading) {
      const ref = element.current;
      try {
        widget = createWidget({
          matchId,
          widgetType,
          element: ref,
          theme: theme || 'LIGHT',
          widgetProps,
          onStateChange: state => {
            if (state === SIRWidgetState.Alive) {
              setWidgetState(SportradarWidgetState.Done);
            } else if (state === SIRWidgetState.Error) {
              setWidgetState(SportradarWidgetState.Error);
            }
          }
        });
        widget.tryStart();
      } catch (_unused) {
        setWidgetState(SportradarWidgetState.Error);
      }
    }
    return () => {
      if (widget) {
        widget.remove();
      }
    };
  }, [loading, matchId, theme, widgetProps, widgetType]);
  const sportRadarStyle = {};
  if (showSkeleton) {
    sportRadarStyle.display = 'none';
  }
  return React.createElement("div", _extends({
    ref: parentElement
  }, props), showSkeleton && React.createElement(SkeletonWrapper, {
    config: skeletonConfig.skeletonConfig
  }), showError && 'Error', React.createElement("div", {
    ref: element,
    style: sportRadarStyle
  }));
};
setGlobal('svs.components.sport.sportWidget.SportradarWidget', SportradarWidget);

 })(window);